var map = {
	"./glyph-0.png": 882701,
	"./glyph-1.png": 642756,
	"./glyph-2.png": 597407,
	"./glyph-3.png": 1078,
	"./glyph-4.png": 100905,
	"./glyph-5.png": 646080,
	"./glyph-6.png": 424411,
	"./glyph-7.png": 10194,
	"./glyph-8.png": 539349,
	"./glyph-9.png": 170252,
	"./glyph-comma.png": 360532,
	"./icon-silver-coin.png": 685273,
	"./img-modal-shell.png": 368832,
	"./img-reward-bar.png": 598017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 239611;